import "../../styles/blocks/general/round-steps.scss";
import "../../styles/blocks/services-page/services-medium-title.scss";
import "../../styles/blocks/services-page/services-middle-content.scss";
import "../../styles/blocks/services-page/services-seo.scss";

import React, {useRef} from "react";
import PropTypes from "prop-types";
import ProcessBlock from "../../components/ProcessBlock";
import useOnScreen from "../../hooks/useOnScreen";
import {Link} from "gatsby";
import createValidLink from "../../helpers/urlFixer";

const ServicesSeo = ({ sectionId, topOverlayBackground, title, description, stepsTitle, stepsBlocks, linkText, linkUrl }) => {
	const wrapper = useRef();
	const isActive = useOnScreen(wrapper, { threshold: 0.7, once: true });
	return (
		<section id={sectionId || "support"} className="services-seo">
			<div className="services-middle-content"
				 style={{
				 	"--top-overlay-background": topOverlayBackground
				 }}
			>
				<div className="container container--medium">
					<div className="services-middle-content__wrapper">
						{title && (
							<h2 className="section-title section-title--black">{title}</h2>
						)}

						{description && (
							<div className="services-middle-content__text" dangerouslySetInnerHTML={{__html: description}}></div>
						)}
					</div>
				</div>
			</div>

			<div className="container container--medium" ref={wrapper}>
				{!!stepsBlocks?.length && (
					<div className="round-steps services-seo__steps">
						{stepsTitle && (
							<h3 className="services-medium-title medium-title">{stepsTitle}</h3>
						)}

						<div className="round-steps__blocks">
							<div className="round-steps__blocks-wrapper">
								{stepsBlocks.map((step) => (
									<ProcessBlock
										active={isActive}
										key={step.number}
										{...step}
										extraClass="process-block--6"
									/>
								))}
							</div>
						</div>
					</div>
				)}

				{linkText && linkUrl && (
					<div className="services-seo__link-wrapper">
						<Link to={createValidLink(linkUrl)} className="button button--large">{linkText}</Link>
					</div>
				)}
			</div>
		</section>
	);
}

ServicesSeo.propTypes = {
	sectionId: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	stepsTitle: PropTypes.string,
	stepsBlocks: PropTypes.array,
	linkText: PropTypes.string,
	linkUrl: PropTypes.string
}

export default ServicesSeo;
